import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import { LoadingScreen } from 'src/components/loading-screen';
import DashboardLayout from 'src/layouts/dashboard';

// ----------------------------------------------------------------------

const AdminDashboard = lazy(() => import('src/pages/admin/dashboard'));
const OrganizationDetailsPage = lazy(() => import('src/pages/admin/organization-details'));
const SuperAdminCardsView = lazy(() => import('src/pages/admin/super-admins'));
const JobRolesPage          = lazy(() => import('src/pages/admin/job-role')); 
// const SkillBuilderPage = lazy(() => import('src/pages/skills/skill-builder'));

// ----------------------------------------------------------------------

export const adminRoutes: RouteObject[] = [
  {
    path: 'admin',
    element: (
      <AuthGuard>
        <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <AdminDashboard />, index: true },
      { path: 'organizations', element: <AdminDashboard /> },
      { path: 'organizations/:organizationId', element: <OrganizationDetailsPage /> },
      { path: 'super-admins', element: <SuperAdminCardsView /> },
      { path: 'job-roles', element: <JobRolesPage /> },
      // { path: 'skill-builder', element: <SkillBuilderPage /> },
    ],
  },
];
